import { videos as rawVideos } from "@/mocks/videos";
import type { Video, VideoCategory } from "@/types/video";

export const allVideos = rawVideos as unknown as Video[];

export const categoryList: {
  slug: VideoCategory;
  name: string;
  en: string;
  short: string;
  description: string;
}[] = [
  {
    slug: "movie",
    name: "电影",
    en: "MOVIE",
    short: "院线佳作与口碑佳作，一次看全",
    description:
      "从悬疑犯罪到温情剧情，从科幻冒险到文艺小品，糖豆视频精选各地高分电影，覆盖内地、港台、日韩与欧美作品，支持按地区、年份与热度快速筛选。",
  },
  {
    slug: "tv",
    name: "电视剧",
    en: "SERIES",
    short: "追更不间断，热剧全集与更新同步",
    description:
      "古装历史、都市悬疑、医疗职场、年代家庭等多题材剧集持续更新，完整收录剧集信息与集数列表，追剧不再错过任何一集。",
  },
  {
    slug: "variety",
    name: "综艺",
    en: "VARIETY",
    short: "真人秀、音乐、脱口秀，轻松下饭",
    description:
      "音乐竞演、户外真人秀、喜剧脱口秀与生活访谈类综艺一网打尽，每期更新信息清晰标注，适合下饭与周末连刷。",
  },
];

export function getCategoryMeta(slug: string) {
  return categoryList.find((item) => item.slug === slug);
}

export const regionOptions = ["全部", "内地", "港台", "日韩", "欧美"];
export const yearOptions = ["全部", "2026", "2025", "2024", "2023", "2022", "2021"];
export const heatOptions = ["全部", "高热度", "人气"];

export type SortKey = "latest" | "hot" | "rating";

export const sortOptions: { key: SortKey; label: string; icon: string }[] = [
  { key: "latest", label: "最新更新", icon: "ri-time-line" },
  { key: "hot", label: "最多热度", icon: "ri-fire-line" },
  { key: "rating", label: "评分最高", icon: "ri-star-line" },
];

export function getVideoById(id?: string) {
  if (!id) return undefined;
  return allVideos.find((item) => item.id === id);
}

export function sortVideos(list: Video[], sort: SortKey) {
  const next = [...list];
  if (sort === "hot") return next.sort((a, b) => b.heat - a.heat);
  if (sort === "rating") return next.sort((a, b) => b.rating - a.rating);
  return next.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export function matchHeat(heat: number, option: string) {
  if (option === "高热度") return heat >= 9000;
  if (option === "人气") return heat >= 5000 && heat < 9000;
  return true;
}

export function getRelatedVideos(video: Video, limit = 6) {
  const scored = allVideos
    .filter((item) => item.id !== video.id)
    .map((item) => {
      let score = 0;
      if (item.category === video.category) score += 3;
      score += item.genre.filter((g) => video.genre.includes(g)).length * 2;
      if (video.actors.some((actor) => item.actors.includes(actor))) score += 3;
      if (Math.abs(item.year - video.year) <= 1) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.heat - a.item.heat);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function formatUpdated(date: string) {
  const [year, month, day] = date.split("-");
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

export function getEpisodeLabel(video: Video) {
  return video.category === "variety" ? "期" : "集";
}

export const siteInfo = {
  name: "糖豆视频",
  slogan: "精选影视综艺高清视频观看平台",
  email: "support@tangdou-video.com",
  phone: "400-820-1688",
  address: "上海市徐汇区龙腾大道 2555 号 糖豆内容中心",
  since: "2019",
};